import { render, staticRenderFns } from "./WaterRatio.vue?vue&type=template&id=00797d0a&scoped=true"
import script from "./WaterRatio.vue?vue&type=script&lang=js"
export * from "./WaterRatio.vue?vue&type=script&lang=js"
import style0 from "./WaterRatio.vue?vue&type=style&index=0&id=00797d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00797d0a",
  null
  
)

export default component.exports